import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Sectors from "./pages/Sectors";
import Opportunities from "./pages/Opportunities";
import Impact from "./pages/Impact";
import Partnerships from "./pages/Partnerships";
import Insights from "./pages/Insights";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/sectors" element={<Sectors />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#0B1A3D",
            border: "1px solid #E2E8F0",
            borderRadius: "9999px",
          },
        }}
      />
    </div>
  );
}

export default App;
